<template lang="html">
  <div>
    <div v-if="loading">
      <pl-spinner style="margin: auto; margin-top: 200px" class="x2" />
    </div>
    <div v-else>
      <table class="integrations-table mv4 w-100">
        <thead>
          <tr class="row no-margin middle-xs">
            <td class="col-xs-4">Integration</td>
            <td class="col-xs-2 center-xs">Class Rostering</td>
            <td class="col-xs-2 center-xs">Assignment & Assessment Sync</td>
            <td class="col-xs-2 center-xs">Connected?</td>
            <td class="col-xs-2 center-xs">Import</td>
          </tr>
        </thead>
        <tbody>
          <tr
            class="row no-margin"
            v-for="(provider, index) in providers"
            :key="index"
          >
            <td class="col-xs-4 truncate-text flex">
              <pl-menu direction="left" :menuSize="4">
                <div slot="menu_trigger">
                  <pl-button class="pl-icon pl-no-margin">
                    <i class="fas fa-ellipsis-v" />
                  </pl-button>
                </div>
                <ul menu-content>
                  <li
                    class="px-2.5 py-1 cursor-pointer"
                    @click="addIntegrationID(provider.integration_id)"
                  >
                    <span>Add Integration ID</span>
                  </li>
                </ul>
              </pl-menu>
              <img
                :src="provider.icon_url"
                height="40px"
                width="40px"
                class="mr-2"
              />
              <div>
                <span class="font-semibold db">{{ provider.name }}</span>
                <a
                  class="view-guide"
                  :href="`https://ed.link/docs/schools/connect/${provider.name.toLowerCase()}`"
                  target="_blank"
                >
                  View Guide
                </a>
              </div>
            </td>
            <td class="flex col-xs-2 center-xs justify-center">
              <img
                v-if="provider.class_rostering"
                src="/static/live_discussion/check_mark.svg"
                alt=""
                height="20px"
                width="20px"
              />
            </td>
            <td class="flex col-xs-2 center-xs justify-center">
              <img
                v-if="provider.assignment_and_assessment_sync"
                src="/static/live_discussion/check_mark.svg"
                alt=""
                height="20px"
                width="20px"
              />
              <span v-else class="b"> - </span>
            </td>
            <td class="col-xs-2 center-xs">
              <span v-if="provider.school_connected" class="td-connected">
                Connected
              </span>
              <span v-else class="b">Not Connected</span>
            </td>
            <td class="col-xs-2 center-xs">
              <pl-button
                v-if="provider.integration_id"
                class="b"
                style="margin: 0; color: #78bec8; font-size: 18px"
                @click.native="
                  $emit(
                    'import_courses_modal',
                    provider.integration_id,
                    provider.name
                  )
                "
              >
                Run Import
              </pl-button>
              <span v-else class="b"> - </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pl-dialog
      v-if="add_integration_modal"
      size="xs"
      :title="'Edlink Integration ID'"
      :disableOutsideClick="true"
      @close="add_integration_modal = false"
    >
      <div class="p-4">
        <pl-input labelText="Integration Id" v-model="integration_id" />
        <div class="center-xs mt4">
          <pl-button class="pl-primary" @click.native="saveIntegrationId">
            SAVE
          </pl-button>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  export default {
    data() {
      return {
        loading: false,
        add_integration_modal: false,
        integration_id: '',
      };
    },
    props: {
      providers: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapGetters(['getProfile']),
      parlayAdmin() {
        return this.getProfile.role === 'admin';
      },
    },
    methods: {
      addIntegrationID(id) {
        this.integration_id = id;
        this.add_integration_modal = true;
      },
      saveIntegrationId() {
        const school_id = this.$route.params.schoolID;
        const integration_id = this.integration_id;
        this.$store
          .dispatch('associateEdlinkIntegrationWithSchool', {
            school_id,
            integration_id,
          })
          .then((data) => {
            if (data) {
              this.$emit('add_integration_id');
              EventBus.$emit('toast-msg', 'New Integration ID saved');
              this.add_integration_modal = false;
            }
          })
          .catch((err) => {
            console.error(err);
            EventBus.$emit('toast-msg', 'Failure. Please try again.');
          });
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';
  .integrations-table
    thead
      td
        padding: 8px
        font-size: 18px
        font-weight: 600
    tbody
      tr
        border: 2px solid #d9d9d9
        border-bottom: none
        align-items: center
        &:last-child
          border-bottom: 2px solid #d9d9d9
      td
        padding: 16px 8px
        font-size: 18px
        font-weight: 500
    .td-connected
      color: #5FA95C
      font-weight: 600

  .pl-icon
    border-radius: 0%
    min-width: 20px
    width: 20px
    min-height: 30px
    height: 30px
  .view-guide
    margin-left: 3px
    font-size: 10px
    line-height: 10px
    color: #3200CC
    text-decoration: underline
</style>



// WEBPACK FOOTER //
// integrationsTable.vue?06038681